<template>
  <h1>RepairList</h1>
</template>

<script>
export default {
  name: "RepairList"
};
</script>

<style></style>
